var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDynamo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "150.917 -341.634 861.235 1081.349",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-0",
    gradientUnits: "userSpaceOnUse",
    x1: 162.585,
    y1: 8.848,
    x2: 162.585,
    y2: 328.5,
    xlinkHref: "#gradient-23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0, 235, 170)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94, 103, 223)"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-1",
    gradientUnits: "userSpaceOnUse",
    x1: 463,
    y1: 12.5,
    x2: 463,
    y2: 289.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-2",
    gradientUnits: "userSpaceOnUse",
    x1: 388.5,
    y1: 65.457,
    x2: 388.5,
    y2: 357.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-3",
    gradientUnits: "userSpaceOnUse",
    x1: 704.751,
    y1: 120.055,
    x2: 704.751,
    y2: 406.858,
    xlinkHref: "#gradient-23"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-4",
    gradientUnits: "userSpaceOnUse",
    x1: 164.045,
    y1: 155.5,
    x2: 164.045,
    y2: 943.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-5",
    gradientUnits: "userSpaceOnUse",
    x1: 541,
    y1: 188.5,
    x2: 541,
    y2: 355.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-6",
    gradientUnits: "userSpaceOnUse",
    x1: 791.5,
    y1: 256.5,
    x2: 791.5,
    y2: 718.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-7",
    gradientUnits: "userSpaceOnUse",
    x1: 190.647,
    y1: 266.5,
    x2: 190.647,
    y2: 502.753,
    xlinkHref: "#gradient-23"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-8",
    gradientUnits: "userSpaceOnUse",
    x1: 508,
    y1: 290.5,
    x2: 508,
    y2: 382.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-9",
    gradientUnits: "userSpaceOnUse",
    x1: 376.5,
    y1: 328.5,
    x2: 376.5,
    y2: 515.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-10",
    gradientUnits: "userSpaceOnUse",
    x1: 453,
    y1: 357.5,
    x2: 453,
    y2: 674.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-11",
    gradientUnits: "userSpaceOnUse",
    x1: 582,
    y1: 353.5,
    x2: 582,
    y2: 388.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-12",
    gradientUnits: "userSpaceOnUse",
    x1: 702,
    y1: 366.5,
    x2: 702,
    y2: 494.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-13",
    gradientUnits: "userSpaceOnUse",
    x1: 636,
    y1: 382.5,
    x2: 636,
    y2: 633.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-14",
    gradientUnits: "userSpaceOnUse",
    x1: 710,
    y1: 495.5,
    x2: 710,
    y2: 629.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-15",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5,
    y1: 502.5,
    x2: 313.5,
    y2: 533.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-16",
    gradientUnits: "userSpaceOnUse",
    x1: 392,
    y1: 516.5,
    x2: 392,
    y2: 738.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-17",
    gradientUnits: "userSpaceOnUse",
    x1: 185,
    y1: 534.5,
    x2: 185,
    y2: 841.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-18",
    gradientUnits: "userSpaceOnUse",
    x1: 733.117,
    y1: 587.443,
    x2: 733.117,
    y2: 874.235,
    xlinkHref: "#gradient-23"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-19",
    gradientUnits: "userSpaceOnUse",
    x1: 550.5,
    y1: 630.5,
    x2: 550.5,
    y2: 819.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-20",
    gradientUnits: "userSpaceOnUse",
    x1: 405,
    y1: 674.5,
    x2: 405,
    y2: 1021.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-21",
    gradientUnits: "userSpaceOnUse",
    x1: 501.5,
    y1: 721.5,
    x2: 501.5,
    y2: 1077.5,
    xlinkHref: "#gradient-23"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-23-22",
    gradientUnits: "userSpaceOnUse",
    x1: 162.531,
    y1: 738.5,
    x2: 162.531,
    y2: 1090.197,
    xlinkHref: "#gradient-23"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995,
      fill: "url(#gradient-23-0)"
    },
    d: "M 195.5 12.5 C 228.582 20.923 255.582 38.59 276.5 65.5 C 291.519 85.363 301.019 107.697 305 132.5 C 306.468 197.811 306.968 263.144 306.5 328.5 C 306.167 328.5 305.833 328.5 305.5 328.5 C 243.764 316.099 182.097 303.265 120.5 290 C 103.832 284.5 88.498 276.667 74.5 266.5 C 40.158 237.483 21.491 200.483 18.5 155.5 C 19.624 100.729 42.957 58.562 88.5 29 C 122.087 9.846 157.754 4.346 195.5 12.5 Z M 132.5 103 C 106.78 121.293 98.946 145.46 109 175.5 C 123.902 204.533 147.402 215.699 179.5 209 C 213.292 195.421 226.292 170.754 218.5 135 C 206.952 106.324 185.619 92.824 154.5 94.5 C 146.795 96.019 139.461 98.852 132.5 103 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995,
      fill: "url(#gradient-23-1)"
    },
    d: "M 195.5,12.5 C 373.807,48.9615 552.141,85.2948 730.5,121.5C 667.251,113.906 617.585,136.239 581.5,188.5C 554.26,221.984 527.26,255.651 500.5,289.5C 426.368,215.201 352.368,140.701 278.5,66C 277.906,65.5357 277.239,65.369 276.5,65.5C 255.582,38.5899 228.582,20.9232 195.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-2)"
    },
    d: "M 276.5,65.5 C 277.239,65.369 277.906,65.5357 278.5,66C 352.368,140.701 426.368,215.201 500.5,289.5C 500.5,289.833 500.5,290.167 500.5,290.5C 482.483,312.521 464.816,334.855 447.5,357.5C 447.167,357.5 446.833,357.5 446.5,357.5C 399.891,347.578 353.224,337.911 306.5,328.5C 306.968,263.144 306.468,197.811 305,132.5C 301.019,107.697 291.519,85.3632 276.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995,
      fill: "url(#gradient-23-3)"
    },
    d: "M 730.5 121.5 C 790.374 135.54 828.541 172.207 845 231.5 C 846.569 239.786 847.735 248.119 848.5 256.5 C 848.704 298.894 834.371 335.561 805.5 366.5 C 771.514 397.328 731.514 410.495 685.5 406 C 656.451 400.32 627.451 394.487 598.5 388.5 C 598.167 388.5 597.833 388.5 597.5 388.5 C 588.236 377.733 578.403 367.4 568 357.5 C 567.79 355.942 567.29 354.609 566.5 353.5 C 564.191 320.51 562.358 287.51 561 254.5 C 562.719 230.847 569.552 208.847 581.5 188.5 C 617.585 136.239 667.251 113.906 730.5 121.5 Z M 659 226.5 C 641.449 250.585 641.116 274.918 658 299.5 C 677.471 321.462 700.971 327.295 728.5 317 C 756.835 301.153 767.335 277.32 760 245.5 C 747.746 216.778 725.913 203.444 694.5 205.5 C 680.524 208.743 668.69 215.743 659 226.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994,
      fill: "url(#gradient-23-4)"
    },
    d: "M 18.5 155.5 C 21.491 200.483 40.158 237.483 74.5 266.5 C 151.132 344.299 272.142 464.711 306.5 502.5 C 313.451 510.145 306.5 523.167 306.5 533.5 C 306.5 533.833 306.5 534.167 306.5 534.5 C 225.15 636.521 144.15 738.855 63.5 841.5 C 35.963 869.913 20.963 903.913 18.5 943.5 C 18.5 680.833 18.5 418.167 18.5 155.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999,
      fill: "url(#gradient-23-5)"
    },
    d: "M 581.5,188.5 C 569.552,208.847 562.719,230.847 561,254.5C 562.358,287.51 564.191,320.51 566.5,353.5C 566.5,354.167 566.5,354.833 566.5,355.5C 544.5,333.833 522.5,312.167 500.5,290.5C 500.5,290.167 500.5,289.833 500.5,289.5C 527.26,255.651 554.26,221.984 581.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994,
      fill: "url(#gradient-23-6)"
    },
    d: "M 848.5,256.5 C 858.833,410.5 869.167,564.5 879.5,718.5C 874.327,676.484 855.327,642.151 822.5,615.5C 783.529,574.862 743.862,534.862 703.5,495.5C 703.5,495.167 703.5,494.833 703.5,494.5C 737.85,452.146 771.85,409.479 805.5,366.5C 834.371,335.561 848.704,298.894 848.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-7)"
    },
    d: "M 74.5 266.5 C 88.498 276.667 103.832 284.5 120.5 290 C 182.097 303.265 244.703 316.099 306.439 328.5 C 306.606 385.501 307.068 445.754 306.568 502.753 C 229.533 425.218 151.132 344.299 74.5 266.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-8)"
    },
    d: "M 500.5,290.5 C 522.5,312.167 544.5,333.833 566.5,355.5C 567.046,364.51 567.713,373.51 568.5,382.5C 527.974,374.473 487.64,366.139 447.5,357.5C 464.816,334.855 482.483,312.521 500.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-9)"
    },
    d: "M 306.5,328.5 C 353.224,337.911 399.891,347.578 446.5,357.5C 407.167,407.004 368,456.671 329,506.5C 326.613,509.957 323.78,512.957 320.5,515.5C 315.833,511.167 311.167,506.833 306.5,502.5C 306.5,444.5 306.5,386.5 306.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-10)"
    },
    d: "M 446.5,357.5 C 446.833,357.5 447.167,357.5 447.5,357.5C 487.64,366.139 527.974,374.473 568.5,382.5C 574.211,466.164 579.878,549.83 585.5,633.5C 549.912,647.363 514.245,661.03 478.5,674.5C 478.167,674.5 477.833,674.5 477.5,674.5C 425.862,621.195 373.528,568.528 320.5,516.5C 320.5,516.167 320.5,515.833 320.5,515.5C 323.78,512.957 326.613,509.957 329,506.5C 368,456.671 407.167,407.004 446.5,357.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-11)"
    },
    d: "M 566.5,353.5 C 567.29,354.609 567.79,355.942 568,357.5C 578.403,367.4 588.236,377.733 597.5,388.5C 587.774,386.755 578.107,384.755 568.5,382.5C 567.713,373.51 567.046,364.51 566.5,355.5C 566.5,354.833 566.5,354.167 566.5,353.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999,
      fill: "url(#gradient-23-12)"
    },
    d: "M 805.5,366.5 C 771.85,409.479 737.85,452.146 703.5,494.5C 668.527,459.194 633.527,423.86 598.5,388.5C 627.451,394.487 656.451,400.32 685.5,406C 731.514,410.495 771.514,397.328 805.5,366.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-13)"
    },
    d: "M 568.5,382.5 C 578.107,384.755 587.774,386.755 597.5,388.5C 597.833,388.5 598.167,388.5 598.5,388.5C 633.527,423.86 668.527,459.194 703.5,494.5C 703.5,494.833 703.5,495.167 703.5,495.5C 667.786,539.879 632.453,584.546 597.5,629.5C 596.833,629.833 596.167,630.167 595.5,630.5C 592.156,631.508 588.823,632.508 585.5,633.5C 579.878,549.83 574.211,466.164 568.5,382.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-14)"
    },
    d: "M 703.5,495.5 C 743.862,534.862 783.529,574.862 822.5,615.5C 780.531,586.465 735.198,579.965 686.5,596C 656.848,607.272 627.182,618.438 597.5,629.5C 632.453,584.546 667.786,539.879 703.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-15)"
    },
    d: "M 306.5,502.5 C 311.167,506.833 315.833,511.167 320.5,515.5C 320.5,515.833 320.5,516.167 320.5,516.5C 315.833,522.167 311.167,527.833 306.5,533.5C 306.5,523.167 306.5,512.833 306.5,502.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-16)"
    },
    d: "M 320.5,516.5 C 373.528,568.528 425.862,621.195 477.5,674.5C 420.718,696.208 363.718,717.541 306.5,738.5C 306.5,670.5 306.5,602.5 306.5,534.5C 306.5,534.167 306.5,533.833 306.5,533.5C 311.167,527.833 315.833,522.167 320.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-17)"
    },
    d: "M 306.5,534.5 C 306.5,602.5 306.5,670.5 306.5,738.5C 238.956,764.074 171.29,789.574 103.5,815C 88.8707,822.129 75.5374,830.963 63.5,841.5C 144.15,738.855 225.15,636.521 306.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995,
      fill: "url(#gradient-23-18)"
    },
    d: "M 822.5 615.5 C 855.327 642.151 874.327 676.484 879.5 718.5 C 882.344 777.314 859.344 822.814 810.5 855 C 801.266 860.286 791.6 864.453 781.5 867.5 C 718.305 884.79 665.305 868.79 622.5 819.5 C 608.474 800.766 599.307 779.766 595 756.5 C 591.725 720.039 588.891 683.539 586.5 647 C 586.494 644.7 586.994 642.534 588 640.5 C 590.761 637.286 593.261 633.953 595.5 630.5 C 596.167 630.167 596.833 629.833 597.5 629.5 C 627.182 618.438 656.848 607.272 686.5 596 C 735.198 579.965 780.531 586.465 822.5 615.5 Z M 692 692.5 C 673.072 717.573 672.739 742.906 691 768.5 C 713.055 791.204 738.222 795.37 766.5 781 C 791.959 762.623 799.792 738.456 790 708.5 C 777.834 683.324 757.667 671.324 729.5 672.5 C 714.75 674.794 702.25 681.46 692 692.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999,
      fill: "url(#gradient-23-19)"
    },
    d: "M 595.5,630.5 C 593.261,633.953 590.761,637.286 588,640.5C 586.994,642.534 586.494,644.7 586.5,647C 588.891,683.539 591.725,720.039 595,756.5C 599.307,779.766 608.474,800.766 622.5,819.5C 589.473,787.14 556.806,754.473 524.5,721.5C 509.167,705.833 493.833,690.167 478.5,674.5C 514.245,661.03 549.912,647.363 585.5,633.5C 588.823,632.508 592.156,631.508 595.5,630.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "url(#gradient-23-20)"
    },
    d: "M 477.5,674.5 C 477.833,674.5 478.167,674.5 478.5,674.5C 493.833,690.167 509.167,705.833 524.5,721.5C 444.833,821.5 365.167,921.5 285.5,1021.5C 296.789,1002.03 303.622,981.034 306,958.5C 306.5,885.167 306.667,811.834 306.5,738.5C 363.718,717.541 420.718,696.208 477.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995,
      fill: "url(#gradient-23-21)"
    },
    d: "M 524.5,721.5 C 556.806,754.473 589.473,787.14 622.5,819.5C 665.305,868.79 718.305,884.79 781.5,867.5C 595.129,938.071 408.463,1008.07 221.5,1077.5C 248.096,1064.91 269.429,1046.24 285.5,1021.5C 365.167,921.5 444.833,821.5 524.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.417404, -350.481598)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995,
      fill: "url(#gradient-23-22)"
    },
    d: "M 306.5 738.5 C 306.667 811.834 306.5 885.167 306 958.5 C 303.622 981.034 296.789 1002.03 285.5 1021.5 C 269.429 1046.24 248.096 1064.91 221.5 1077.5 C 176.104 1096.64 131.771 1094.14 88.5 1070 C 42.956 1040.44 19.623 998.268 18.5 943.5 C 20.963 903.913 35.963 869.913 63.5 841.5 C 75.537 830.963 88.871 822.129 103.5 815 C 171.29 789.574 238.956 764.074 306.5 738.5 Z M 109 923.5 C 99.566 950.263 105.399 973.096 126.5 992 C 155.964 1011.03 183.131 1008.2 208 983.5 C 223.442 962.753 225.442 940.753 214 917.5 C 200.823 896.326 181.657 886.326 156.5 887.5 C 134.535 891.286 118.701 903.286 109 923.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamo);
export default __webpack_public_path__ + "static/media/dynamo.0d073486957d000c3f8c766c37162ca5.svg";
export { ForwardRef as ReactComponent };